(() => {
  const header = document.querySelector('[data-kaw-header]');
  if (!header) return;

  const toggle = header.querySelector('[data-kaw-drawer-toggle]');
  const controller = new AbortController();
  const { signal } = controller;

  const setHeaderHeight = () => {
    document.documentElement.style.setProperty('--kaw-header-height', `${header.offsetHeight}px`);
  };

  const closeDrawer = () => {
    header.classList.remove('kaw-header--open');
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.style.removeProperty('overflow');
  };

  if (toggle) {
    toggle.addEventListener(
      'click',
      () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        if (open) {
          closeDrawer();
        } else {
          setHeaderHeight();
          header.classList.add('kaw-header--open');
          toggle.setAttribute('aria-expanded', 'true');
          document.documentElement.style.setProperty('overflow', 'hidden');
        }
      },
      { signal }
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          closeDrawer();
          toggle.focus();
        }
      },
      { signal }
    );
  }

  const topLevelDrawerDetails = header.querySelectorAll('.kaw-header__drawer-list > .kaw-header__drawer-item > details.kaw-header__drawer-details');
  topLevelDrawerDetails.forEach((details) => {
    details.addEventListener('toggle', () => {
      if (details.open) {
        topLevelDrawerDetails.forEach((other) => {
          if (other !== details && other.open) other.open = false;
        });
      } else {
        details.querySelectorAll('details[open]').forEach((nested) => { nested.open = false; });
      }
    }, { signal });
  });

  header.querySelectorAll('[data-kaw-mega-link]').forEach((link) => {
    const item = link.closest('.kaw-header__item--mega');
    if (!item) return;
    const sync = (expanded) => link.setAttribute('aria-expanded', String(expanded));
    item.addEventListener('mouseenter', () => sync(true), { signal });
    item.addEventListener('mouseleave', () => sync(false), { signal });
    item.addEventListener('focusin', () => sync(true), { signal });
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) sync(false);
    }, { signal });
  });

  const searchToggle = header.querySelector('[data-kaw-search-toggle]');
  if (searchToggle) {
    searchToggle.addEventListener(
      'click',
      () => {
        const open = header.classList.toggle('kaw-header--search-open');
        searchToggle.setAttribute('aria-expanded', String(open));
        if (open) {
          const input = header.querySelector('#KawHeaderSearchInput');
          if (input) input.focus();
        }
      },
      { signal }
    );
  }

  document.querySelectorAll('[data-kaw-back]').forEach((back) => {
    back.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        history.back();
      },
      { signal }
    );
  });

  const setCartCount = (itemCount) => {
    document.querySelectorAll('[data-kaw-cart-count]').forEach((counter) => {
      counter.textContent = itemCount;
      counter.classList.toggle('kaw-cart-count--empty', itemCount === 0);
    });
  };
  const refreshCartCount = async () => {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      const cart = await response.json();
      setCartCount(cart.item_count);
    } catch {
      /* keep the server-rendered count */
    }
  };
  document.addEventListener('shopify:cart:lines-update', (event) => {
    // Horizon's CartLinesUpdateEvent resolves the authoritative count on event.promise
    if (event.promise) {
      event.promise
        .then(({ cart, detail }) => setCartCount(cart?.totalQuantity ?? detail?.itemCount ?? 0))
        .catch(() => {});
    } else {
      refreshCartCount();
    }
  }, { signal });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshCartCount();
  }, { signal });

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { signal });
  window.addEventListener('pagehide', () => controller.abort(), { signal });
})();
